<style lang="scss">
.productionAllRowTable::before {
  z-index: inherit;
}

.productionAllRowTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.productionAllRowTable.el-table {
  background-color: transparent;
}

.productionAllRowTable.el-table--border:after,
.productionAllRowTable.el-table--group:after,
.productionAllRowTable.el-table:before {
  background-color: transparent;
}

.productionAllRowTable.el-table tr {
  background-color: transparent;
}

.productionAllRowTable.el-table td.gutter,
.productionAllRowTable.el-table th.gutter {
  background: #33333a;
}

.productionAllRowTable .el-table__body-wrapper {
  background: #1d1d24;
}

// 滚动条的宽度
.productionAllRowTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.productionAllRowTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

.gridMode::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

.gridMode::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

// .productionAllRowTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	/*滚动条里面轨道*/
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
</style>

<style scoped></style>
<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <setting v-show="false"></setting>
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('shengchanjindu') }}
        </p>
      </div>
      <!-- v-show="sumProductAndPlanNumber[0]&&sumProductAndPlanNumber[1]" -->
      <p style="font-size: 14px;line-height: 22px;color: #F4F4F4;">{{ $t('dingdanchanchudachenglv') }}{{ sumProductAndPlanNumber[2] }}（{{ sumProductAndPlanNumber[0] }}/{{ sumProductAndPlanNumber[1] }}）{{ $t('gongdanshuliang') + ':' + listSize }}</p>
      <div style="margin-left: 18px;display: flex;">
        <div @click="showMode = 'grid'" :style="{ 'background-color': showMode == 'grid' ? 'rgba(65, 159, 255, 0.2)' : '' }" style="width: 28px;height: 24px;display: flex;justify-content: center;align-items: center;cursor: pointer;">
          <i style="font-size: 14px;color: #419FFF;" class="yicon yicon-a-grid_fill1"></i>
        </div>
        <div @click="showMode = 'list'" :style="{ 'background-color': showMode == 'list' ? 'rgba(65, 159, 255, 0.2)' : '' }" style="width: 28px;height: 24px;display: flex;justify-content: center;align-items: center;cursor: pointer;margin-left: 10px;">
          <i style="font-size: 14px;color: #419FFF;" class="yicon yicon-list_check"></i>
        </div>
        <!-- <p style="font-size: 12px;line-height: 22px;color: #E9E9EB;">
					{{$t('统计时间09-28 08:00 ~ 09-29 08:00')}}
				</p> -->
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <el-table v-show="showMode == 'list'" ref="table" class="productionAllRowTable" :data="progresses" style="width: 100%" :max-height="contentHeight" :row-style="{ background: '#1D1D24', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: '#202027', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: '#33333A', color: '#E9E9EB', padding: '0px', height: '42px', borderColor: '#33333A', 'font-size': '14px' }">
        <template v-for="(col, index) in monitorSetting.PRODUCTION_ALL_COLUMNS">
          <el-table-column :sortable="true" v-if="col == 'shebeimingcheng'" prop="equipment.name" :label="$t('shebeimingcheng')"> </el-table-column>
          <el-table-column :sortable="true" v-else-if="col == 'shengchangongdanhao'" prop="no" :label="$t('shengchangongdanhao')"> </el-table-column>
          <el-table-column :sortable="true" v-else-if="col == 'chanpinbianma'" prop="material.code" :label="$t('chanpinbianma')"> </el-table-column>
          <el-table-column :sortable="true" v-else-if="col == 'chanpinmingcheng'" prop="material.name" :label="$t('chanpinmingcheng')"> </el-table-column>
          <el-table-column :sortable="true" v-else-if="col == 'mojubianhao'" prop="mould.code" :label="$t('mojubianhao')"> </el-table-column>
          <el-table-column v-else-if="col == 'gongdanzhuangtai'" :label="$t('gongdanzhuangtai')">
            <template slot-scope="scope">
              <div style="line-height: 28px;">
                <span :style="{ color: status[scope.row.status].color, 'border-color': status[scope.row.status].color, background: status[scope.row.status].tagBg }" style="border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;border: 1px solid;">{{ status[scope.row.status].title }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column v-else-if="col == 'jihuashuliang'" prop="planQuantity" :label="$t('jihuashuliang')"> </el-table-column>
          <el-table-column v-else-if="col == 'shengchanshuliang'" :label="$t('shengchanshuliang')">
            <template slot-scope="scope">
              <div v-if="scope.row.productionQuantity > scope.row.planQuantity && $attrs.which == 'producing'" style="color: #FFC83A;font-size: 16px;border: 1px solid #FFC83A;display: inline-block;padding: 0px 4px;">
                {{ scope.row.productionQuantity }}
              </div>
              <div v-else style="color: white;font-size: 16px;">
                {{ scope.row.productionQuantity }}
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'yibaogongliangpinshu'" prop="finishGoodQuantity" :label="$t('yibaogongliangpinshu')"> </el-table-column>
          <el-table-column v-else-if="col == 'yibaogongbuliangpinshu'" prop="finishBadQuantity" :label="$t('yibaogongbuliangpinshu')"> </el-table-column>
          <el-table-column v-else-if="col == 'shengyushengchanshuliang'" prop="leftProductionQuantity" :label="$t('shengyushengchanshuliang')"> </el-table-column>
          <el-table-column v-else-if="col == 'liangpinlv'" :label="$t('liangpinlv')">
            <template slot-scope="scope">
              <span v-if="scope.row.finishGoodQuantity != null && scope.row.finishBadQuantity != null && scope.row.finishGoodQuantity + scope.row.finishBadQuantity > 0">
                {{ ((scope.row.finishGoodQuantity / (scope.row.finishGoodQuantity + scope.row.finishBadQuantity)) * 100).toFixed(1) + '%' }}
              </span>
              <span v-else>
                -
              </span>
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'biaozhun/shishizhouqi（miao）'" :label="$t('biaozhun/shishizhouqi（miao）')">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.standardCycle).toFixed(1) }}/
              {{ parseFloat(scope.row.actualCycle ? scope.row.actualCycle : 0).toFixed(1) }}
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'shengchanjindu' && $attrs.which != 'waiting'" :label="$t('shengchanjindu')" :width="maxFlowWidth">
            <template slot-scope="scope">
              <div style="transform-origin: 0px 0px;transform: scale(0.8);margin-left: -40px;" :style="{ width: flowWidths['web_monitor_production_all_list_' + $attrs.which + '_' + scope.$index] != null ? flowWidths['web_monitor_production_all_list_' + $attrs.which + '_' + scope.$index] + 80 + 'px' : '100%', height: (flowHeights['web_monitor_production_all_list_' + $attrs.which + '_' + scope.$index] != null ? flowHeights['web_monitor_production_all_list_' + $attrs.which + '_' + scope.$index] : 100) + 'px' }" :id="'web_monitor_production_all_list_' + $attrs.which + '_' + scope.$index"></div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'wangongyuceshijian'" :label="$t('wangongyuceshijian')">
            <template slot-scope="scope">
              {{ scope.row.preFinishTime != null ? dayjs.unix(scope.row.preFinishTime / 1000).format('YYYY-MM-DD HH:mm') : '' }}
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'beizhu'" :label="$t('beizhu')" prop="remark"> </el-table-column>
        </template>
      </el-table>

      <div class="gridMode" v-show="showMode == 'grid'" ref="grids" :style="{ height: contentHeight + 'px' }" style="padding-top: 0;display: grid;grid-template-columns:1fr 1fr 1fr ;grid-row-gap: 12px;grid-column-gap: 12px;overflow: auto;">
        <div style="padding:20px;border-radius: 2px;height: auto;" :style="{ background: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? '#121212' : status[progress.status].cardBg }" v-for="(progress, index) in progresses">
          <div style="display: flex;align-items: center;">
            <p v-if="monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue'" :style="{ color: status[progress.status].color }" style="font-size: 34px;font-weight: 700;">
              {{ progress.equipment.name }}
            </p>
            <p :style="{ color: status[progress.status].color }" v-else style="font-size: 34px;font-weight: 700;background: rgba(255, 255, 255, 0.85);border-radius: 10px;padding: 2px 9px;">
              {{ progress.equipment.name }}
            </p>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 14px;flex-flow: wrap;">
            <template v-for="(col, index) in monitorSetting.PRODUCTION_ALL_COLUMNS">
              <div v-if="col == 'shengchangongdanhao'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 16px;">
                  {{ $t('shengchangongdanhao') }}
                </p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.no }}
                </p>
              </div>
              <div v-else-if="col == 'chanpinbianma'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{ $t('chanpinbianma') }}</p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.material && progress.material.code }}
                </p>
              </div>
              <div v-else-if="col == 'chanpinmingcheng'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{ $t('chanpinmingcheng') }}</p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.material && progress.material.name }}
                </p>
              </div>
              <div v-else-if="col == 'mojubianhao'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{ $t('mojubianhao') }}</p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.mould.no }}
                </p>
              </div>
              <div v-else-if="col == 'gongdanzhuangtai'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{ $t('gongdanzhuangtai') }}</p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ status[progress.status].title }}
                </p>
              </div>
              <div v-else-if="col == 'jihuashuliang'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{ $t('jihuashuliang') }}</p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.planQuantity }}
                </p>
              </div>
              <div v-else-if="col == 'shengchanshuliang'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{ $t('shengchanshuliang') }}</p>

                <div v-if="progress.productionQuantity > progress.planQuantity && $attrs.which == 'producing'" style="color: #FFC83A;font-size: 16px;margin-top: 6px;font-weight:700;border: 1px solid #FFC83A;display: inline-block;padding: 0 4px;">
                  {{ progress.productionQuantity }}
                </div>
                <p v-else :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.productionQuantity }}
                </p>
              </div>

              <div v-else-if="col == 'yibaogongliangpinshu'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 16px;">
                  {{ $t('yibaogongliangpinshu') }}
                </p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.finishGoodQuantity }}
                </p>
              </div>
              <div v-else-if="col == 'yibaogongbuliangpinshu'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 16px;">
                  {{ $t('yibaogongbuliangpinshu') }}
                </p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.finishBadQuantity }}
                </p>
              </div>
              <div v-else-if="col == 'shengyushengchanshuliang'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 16px;">
                  {{ $t('shengyushengchanshuliang') }}
                </p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.leftProductionQuantity }}
                </p>
              </div>
              <div v-else-if="col == 'liangpinlv'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{ $t('liangpinlv') }}</p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  <span v-if="progress.finishGoodQuantity != null && progress.finishBadQuantity != null && progress.finishGoodQuantity + progress.finishBadQuantity > 0">
                    {{ ((progress.finishGoodQuantity / (progress.finishGoodQuantity + progress.finishBadQuantity)) * 100).toFixed(1) + '%' }}
                  </span>
                  <span v-else>
                    -
                  </span>
                </p>
              </div>

              <div v-else-if="col == 'biaozhun/shishizhouqi（miao）'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 16px;">
                  {{ $t('biaozhun/shishizhouqi（miao）') }}
                </p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ parseFloat(progress.standardCycle).toFixed(1) }}/
                  {{ parseFloat(progress.actualCycle ? progress.actualCycle : 0).toFixed(1) }}
                </p>
              </div>

              <div v-else-if="col == 'wangongyuceshijian'" style="width: 32%;margin-bottom: 16px;">
                <p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{ $t('wangongyuceshijian') }}</p>
                <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                  {{ progress.preFinishTime != null ? dayjs.unix(progress.preFinishTime / 1000).format('YYYY-MM-DD HH:mm') : '' }}
                </p>
              </div>
            </template>
            <div style="width: 32%;margin-bottom: 16px;">
              <p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{ $t('beizhu') }}</p>
              <p :style="{ color: monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE == 'jianyue' ? status[progress.status].color : '#ffffff' }" style="font-size: 16px;margin-top: 6px;font-weight:700;">
                {{ progress.remark ? progress.remark : '-' }}
              </p>
            </div>
            <!-- <div style="width: 100%;margin-bottom: 16px;">
							<p style="color: #E9E9EB;line-height: 22px;font-size: 14px;">{{$t('beizhu')}}</p>
							<p :style="{'color':monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE=='jianyue'?status[progress.status].color:'#ffffff'}"
								style="font-size: 16px;margin-top: 6px;font-weight:700;">
								{{progress.remark?progress.remark:'-'}}
							</p>
						</div> -->
          </div>
          <div v-if="$attrs.which != 'waiting'" style="width: 100%;height: 1px;background-color: #C0C4CC;margin-top: 10px;"></div>
          <!-- 必须锁定组件外框定宽 -->
          <div v-if="$attrs.which != 'waiting'" :style="{ width: cardWidth + 'px' }" style="overflow: hidden;margin-left: -40px;">
            <!-- <auto_scroll> -->
            <div :style="{ width: flowWidths['web_monitor_production_all_grid_' + $attrs.which + '_' + index] != null ? flowWidths['web_monitor_production_all_grid_' + $attrs.which + '_' + index] + 'px' : '100%', height: (flowHeights['web_monitor_production_all_grid_' + $attrs.which + '_' + index] != null ? flowHeights['web_monitor_production_all_grid_' + $attrs.which + '_' + index] : 100) + 'px' }" :id="'web_monitor_production_all_grid_' + $attrs.which + '_' + index"></div>
            <!-- </auto_scroll> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
// import {
// 	Graph as x6
// } from "@antv/x6";

// import {
// 	DagreLayout as x6layout
// } from '@antv/layout'
import setting from '@@/pages/web/monitor/production_all/setting';
export default {
  name: 'web_monitor_production_all_row',
  components: {
    setting: setting
  },
  data() {
    return {
      flowHeights: {},
      flowWidths: {},
      x6s: {},
      monitorSetting: {},
      listSize: 0,
      status: {
        '1': {
          color: 'rgba(65, 159, 255, 1)',
          title: this.$t('xinjian'),
          tagBg: 'rgba(65, 159, 255, 0.2)',
          cardBg: 'linear-gradient(180deg, #2686E9 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '2': {
          color: 'rgba(65, 159, 255, 1)',
          title: this.$t('fafang'),
          tagBg: 'rgba(65, 159, 255, 0.2)',
          cardBg: 'linear-gradient(180deg, #2686E9 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '3': {
          color: '#39F16D',
          title: this.$t('shengchanzhong'),
          tagBg: 'rgba(57, 241, 109, 0.2)',
          cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '4': {
          color: 'rgba(255, 58, 94, 1)',
          title: this.$t('zanting'),
          tagBg: 'rgba(255, 58, 94, 0.2)',
          cardBg: 'linear-gradient(180deg, #FF3A5E 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '5': {
          color: '#39F16D',
          title: this.$t('shougongxuwangong'),
          tagBg: 'rgba(57, 241, 109, 0.2)',
          cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '6': {
          color: '#39F16D',
          title: this.$t('wangong'),
          tagBg: 'rgba(57, 241, 109, 0.2)',
          cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '7': {
          color: 'rgba(153, 160, 173, 1)',
          title: this.$t('guanbi'),
          tagBg: 'rgba(153, 160, 173, 0.2)',
          cardBg: 'linear-gradient(180deg, #A5A5A5 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '8': {
          color: 'rgba(255, 200, 58, 1)',
          title: this.$t('yidiaobo'),
          tagBg: 'rgba(255, 200, 58, 0.2)',
          cardBg: 'linear-gradient(180deg, #FA9D2D 0%, rgba(18, 18, 18, 0) 100%)'
        }
      },
      interval: null,
      timmer: null,
      contentHeight: 0,
      rowHeight: 0,
      cardWidth: 0,
      progresses: [],
      showMode: 'grid',
      isStopListScroll: false,
      isStopGridScroll: false
    };
  },
  created() {

    this.timmer = setInterval(() => {
      this.listProductionProgress();
    }, 120000);
    this.listProductionProgress();
  },
  mounted() {
    this.resize();
    this.setProductionAll();
    this.utils.event_hub.$on('SetProductionAll', () => {
      this.setProductionAll();
    });
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    console.log(444444444444444444);
    this.utils.event_hub.$off('SetProductionAll');
    clearInterval(this.timmer);
    clearInterval(this.interval);
  },

  activated() {
    setTimeout(() => {
      this.initPie(this.showMode);
    }, 500);
  },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listProductionProgress();
    },
    showMode(newValue, oldValue) {
      setTimeout(() => {
        this.initPie(this.showMode);
      }, 500);
    }
  },
  computed: {
    sumProductAndPlanNumber() {
      let planQuantity = 0;
      let productionQuantity = 0;
      for (var i = 0; i < this.progresses.length; i++) {
        planQuantity += this.progresses[i].planQuantity;
        productionQuantity += this.progresses[i].productionQuantity;
      }
      return [productionQuantity, planQuantity, ((productionQuantity / planQuantity) * 100).toFixed(1) + '%'];
    },
    maxFlowWidth() {
      let max = 0;
      for (var i = 0; i < this.progresses.length; i++) {
        if (this.flowWidths['web_monitor_production_all_list_' + this.$attrs.which + '_' + i] > max) {
          max = this.flowWidths['web_monitor_production_all_list_' + this.$attrs.which + '_' + i];
        }
      }
      return max;
    }
  },
  methods: {
    setProductionAll() {
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      const gridDiv = this.$refs.grids;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
        if (!this.isStopGridScroll) {
          gridDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (gridDiv.clientHeight + gridDiv.scrollTop >= gridDiv.scrollHeight) {
            this.isStopGridScroll = true;
            setTimeout(() => {
              if (gridDiv.clientHeight + gridDiv.scrollTop >= gridDiv.scrollHeight) {
                gridDiv.scrollTop = 0;
              }
              this.isStopGridScroll = false;
            }, 5000);
          }
        }
        //console.log(listDiv.clientHeight,listDiv.scrollTop,listDiv.scrollHeight)
        // console.log(gridDiv.clientHeight,gridDiv.scrollTop,gridDiv.scrollHeight)
      }, 100);
    },

    async listProductionProgress() {
      let url = '';
      if (this.$attrs.which == 'all') {
        url = '/web/production/wo/monitor/progress/all';
      } else if (this.$attrs.which == 'producing') {
        url = '/web/production/wo/monitor/progress/inproduction';
      } else if (this.$attrs.which == 'waiting') {
        url = '/web/production/wo/monitor/progress/awaiting';
      }
      let response = await this.http.get(url, {
        params: {
          orgId: this.$attrs.orgId
        }
      });
      this.progresses = response.data;
      this.listSize = this.progresses.length;
      this.$nextTick(() => {
        this.initPie(this.showMode);
      });
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (this.$refs.titleBar == null) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 10;
        this.cardWidth = (this.$refs.container.clientWidth - 40) * 0.3;
      }, 800);
    },
    initPie(listOrGrid) {
      for (var i = 0; i < this.progresses.length; i++) {
        let woProcedureList = this.progresses[i].woProcedureList;
        let nodes = woProcedureList.map(item => {
          return {
            id: item.routeWorkProcedureId + '',
            shape: 'node4',
            width: 83,
            height: 60,
            data: {
              id: 'web_monitor_production_all_pie_' + listOrGrid + '_' + this.$attrs.which + '_' + i + '_' + item.routeWorkProcedureId,
              color: this.status[this.progresses[i].status].color,
              title: item.procedureDesc,
              percent: item.finishGoodQuantity / item.planQuantity
            }
          };
        });

        let edges = [];
        for (var j = 0; j < woProcedureList.length; j++) {
          let node = woProcedureList[j];
          if (woProcedureList[j].parentIds == '') {
            continue;
          }
          let parentIdArr = woProcedureList[j].parentIds.split(',');
          for (var k = 0; k < parentIdArr.length; k++) {
            edges.push({
              attrs: {
                line: {
                  targetMarker: {
                    tagName: 'circle',
                    r: 2,
                    cx: 2,
                    fill: '#C0C4CC',
                    stroke: '#C0C4CC'
                  },
                  stroke: '#C0C4CC',
                  strokeWidth: 1
                }
              },
              source: parentIdArr[k],
              target: node.routeWorkProcedureId + '',
              router: {
                name: 'manhattan',
                startDirections: ['right'],
                endDirections: ['left']
              }
            });
          }
        }

        this.initFlow('web_monitor_production_all_' + listOrGrid + '_' + this.$attrs.which + '_' + i, nodes, edges);

        this.countFlowHeihgt(listOrGrid);
      }
    },

    initFlow(id, nodes, edges) {
      if (this.x6s[id + '_graph']) {
        this.x6s[id + '_graph'].clearCells();
      }
      if (this.x6s[id + '_x6']) {
        this.x6s[id + '_x6'].clearCells();
      }
      this.x6s[id + '_x6'] = undefined;
      this.x6s[id + '_model'] = undefined;
      this.x6s[id + '_graph'] = undefined;
      if (document.getElementById(id) == null) {
        return;
      }
      document.getElementById(id).innerHTML = '';

      //this.graph
      this.x6s[id + '_x6'] = new this.x6({
        container: document.getElementById(id),
        width: 'auto',
        height: 'auto',
        grid: false,
        interacting: {
          nodeMovable: false
        }
      });

      let model = {
        nodes: nodes,
        edges: edges
      };
      let dagreLayout = new this.x6layout({
        type: 'dagre',
        rankdir: 'LR',
        align: 'UL',
        // rankdir: 'TB',
        // align: 'DR',
        ranksep: 25,
        nodesep: 10,
        controlPoints: true
      });
      //const newModel

      this.x6s[id + '_model'] = dagreLayout.layout(model);
      this.x6s[id + '_graph'] = this.x6s[id + '_x6'].fromJSON(this.x6s[id + '_model']);

      //let a =this.graph.fromJSON(newModel)
      //a = null
      // nodes=null
      // edges=null
      // model = null
      // dagreLayout = null
      // this.models[id] = dagreLayout.layout(model)
      // this.graph.fromJSON(this.models[id])
    },
    countFlowHeihgt(listOrGrid) {
      if (!listOrGrid) {
        listOrGrid = this.showMode;
      }
      setTimeout(() => {
        for (var i = 0; i < this.progresses.length; i++) {
          let id = 'web_monitor_production_all_' + listOrGrid + '_' + this.$attrs.which + '_' + i;
          this.flowHeights[id] =
            document
              .getElementById(id)
              .getElementsByClassName('x6-graph-svg-viewport')[0]
              .getBoundingClientRect().height + 40;
          this.flowWidths[id] =
            document
              .getElementById(id)
              .getElementsByClassName('x6-graph-svg-viewport')[0]
              .getBoundingClientRect().width + 40;
        }
      }, 600);
    }
  }
};
</script>
